import React from "react";
import {
  negociosSegurosOptions,
  PRENDARIOS,
  MERCADO_ABIERTO,
} from "~constants/negocios";
import ColorLabel from "../colorLabel/ColorLabel";

import { makeStyles } from "@mui/styles";

// ColorLabel todavía no está migrado a TS: se tipa localmente lo que consume este componente.
const ColorLabelTyped = ColorLabel as unknown as React.ComponentType<{
  text: React.ReactNode;
  variant?: string;
}>;

const useStyles = makeStyles((theme) => ({
  dash: { display: "flex", alignItems: "center", justifyContent: "center" },
}));

interface ColorLabelNegocioProps {
  negocio: string | null;
  abbreviated?: boolean;
}

const ColorLabelNegocio: React.FC<ColorLabelNegocioProps> = ({
  negocio,
  abbreviated,
}) => {
  const classes = useStyles();

  const isPrendarios = negocio === PRENDARIOS;

  const isMercadoAbierto = negocio === MERCADO_ABIERTO;

  return (
    <>
      {isPrendarios && (
        <ColorLabelTyped
          variant={"info"}
          text={abbreviated ? "PR" : negociosSegurosOptions[PRENDARIOS]}
        />
      )}
      {isMercadoAbierto && (
        <ColorLabelTyped
          variant={"otros"}
          text={abbreviated ? "MA" : negociosSegurosOptions[MERCADO_ABIERTO]}
        />
      )}
      {!isPrendarios && !isMercadoAbierto && (
        <ColorLabelTyped
          text={
            abbreviated ? (
              <span className={classes.dash}>&mdash;</span>
            ) : (
              "Indeterminado"
            )
          }
        />
      )}
    </>
  );
};

export default ColorLabelNegocio;
